import { ACCESS_CODE_LENGTH } from 'src/constants';
import { useGetAccessCodeDataQuery } from './authentication/AccessCodeApi';
import { useGetTransactionInformationQuery } from './localStorage/TransactionInformationStorageApi';

export const useTransactionInformation = () => {
  const { data: transactionInformation, isFetching, error, isSuccess } = useGetTransactionInformationQuery();
  const accesscode = transactionInformation?.value?.accesscode;
  const state = transactionInformation?.value?.state;

  const {
    currentData,
    error: getAccessCodeError,
    isSuccess: getAccessCodeSuccess,
    isFetching: getAccessCodeIsFetching,
    refetch,
  } = useGetAccessCodeDataQuery(accesscode ?? '', {
    skip: accesscode?.length !== ACCESS_CODE_LENGTH,
  });

  const isReady =
    isSuccess &&
    !isFetching &&
    !error &&
    (accesscode?.length !== ACCESS_CODE_LENGTH ||
      ((getAccessCodeError || getAccessCodeSuccess) && !getAccessCodeIsFetching));

  return { info: { accesscode, state }, data: currentData, isReady, error: error ?? getAccessCodeError, refetch };
};
